export default {
  // Common
  common: {
    loading: 'Loading...',
    selectYourLanguage: 'Select your language',
    error: 'Error',
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    back: 'Back',
    next: 'Next',
    download: 'Download',
    reset: 'Reset',
    delete: 'Delete',
    edit: 'Edit',
    yes: 'Yes',
    no: 'No',
    search: 'Search',
    filter: 'Filter',
    menu: 'Menu',
    saved: 'Saved',
    continued: 'continued',
    currency: {
      USD: "US Dollars (USD)",
      MXN: "Mexican Pesos (MXN)",
      EUR: "Euros (EUR)",
      GBP: "British Pounds (GBP)",
      JPY: "Japanese Yen (JPY)",
      CNY: "Chinese Yuan (CNY)",
      RUB: "Russian Rubles (RUB)"
    },
    copyright: 'All rights reserved.',
    per: 'per',
    liter: 'Liter',
    gallon: 'Gallon',
    unit: 'Unit',
    and: 'and',
    close: 'Close',
    continue: 'Continue',
    hours: 'hours',
    minutes: 'minutes',
    currency_preference: 'Preferred Currency'
  },
  
  // Auth forms
  auth: {
    login: 'Sign In',
    register: 'Create Account',
    email: 'Email Address',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    fullName: 'Full Name',
    company: 'Company (Optional)',
    city: 'City',
    postalCode: 'Postal Code',
    phoneNumber: 'Phone Number',
    phoneNoSpaces: 'No dashes or spaces',
    forgotPassword: 'Forgot your password?',
    passwordRequirements: {
      title: 'Your password must have:',
      length: 'At least 8 characters',
      uppercase: 'At least one uppercase letter',
      number: 'At least one number',
      special: 'Special character (recommended)'
    },
    agreedToTerms: 'I have read and agree to the',
    termsAndConditions: 'Terms and Conditions',
    privacyPolicy: 'Privacy Policy',
    rememberMe: 'Remember my data on this device',
    noAccount: "Don't have an account? Sign up",
    haveAccount: 'Already have an account? Sign in',
    resetPassword: 'Reset Password',
    resetPasswordInstructions: 'Enter your registered email address and we will send you a link to reset your password.',
    sendResetLink: 'Send Recovery Link',
    resetPasswordSuccess: 'A recovery link has been sent to your email address',
    emailConfirmation: {
      title: 'Registration Successful!',
      subtitle: 'Confirm your email address to be able to sign in',
      instructionsTitle: 'Instructions:',
      step1Title: 'Check your email:',
      step1Description: 'We have sent a confirmation link to',
      step2Title: 'Click on the link:',
      step2Description: 'Open the email and click on the confirmation link.',
      step3Title: 'Sign in:',
      step3Description: 'Once confirmed, return here to sign in and receive your 5 free credits.',
      freeCreditsMessage: '5 free credits await you after confirming your email',
      backToLogin: 'Return to Sign In',
      noEmailReceived: "Didn't receive the email? Check your spam or junk folder."
    },
    benefits: {
      title: 'Why use Cotizatrin?',
      accurate: {
        title: 'Accurate Quotations',
        description: 'Get precise transportation quotes based on real-time data and toll information'
      },
      time: {
        title: 'Save Time',
        description: 'Generate professional quotes in minutes instead of hours of manual calculations'
      },
      professional: {
        title: 'Professional PDFs',
        description: 'Download detailed and customized PDFs ready to share with your clients'
      },
      tollData: {
        title: 'Updated Toll Data',
        description: 'Access current toll costs on all major routes in Mexico'
      },
      pesos: 'pesos',
      globalCountryOption: 'Global (all countries)',
      multiCurrency: {
        title: 'Multiple Currencies',
        description: 'View and export quotes in different currencies for international clients'
      },
      security: {
        title: 'Specialized Security',
        description: 'Receive personalized security recommendations based on cargo type'
      },
      quotationsGenerated: 'Quotations generated'
    }
  },
  
  // Dashboard
  dashboard: {
    welcome: 'Welcome,',
    newQuotation: 'New Quotation',
    quotationHistory: 'Quotation History',
    adminPanel: 'Admin Panel',
    advancedMode: 'Advanced',
    formGuide: 'Form Guide',
    additionalInfo: 'Additional Information',
    additionalResources: 'Additional Resources',
    logout: 'Logout',
    completeForms: 'Complete the form to get a detailed quotation.'
  },
  
  // Quotation Form
  quotationForm: {
    title: 'Transportation Quotation',
    subtitle: 'Complete the form to generate a detailed quotation',
    vehicleConfig: 'Vehicle Configuration',
    vehicleType: 'Vehicle Type',
    trailerType: 'Trailer Type',
    noTrailer: 'No Trailer',
    cargoType: 'Cargo Type',
    selectCargoType: 'Select cargo type',
    riskFactor: 'Risk factor for this cargo',
    costParams: 'Cost Parameters',
    fuelPrice: 'Fuel Price',
    profitMargin: 'Profit Margin',
    taxVat: 'VAT/Tax',
    taxDiscountHelp: 'Select the applicable tax percentage to get the adjusted cost of tolls without VAT.',
    taxDiscountNote: 'This percentage is applied as a discount to the toll cost to calculate the price without VAT.',
    transportRoute: 'Transport Route',
    transportRouteDescription: 'Define the origin, destination and any intermediate stops for your transport',
    origin: 'Origin',
    destination: 'Destination',
    enterOrigin: 'Enter origin location',
    enterDestination: 'Enter destination location',
    routeInfo: 'Route Information:',
    distance: 'Distance:',
    estTime: 'Estimated time:',
    totalDistance: 'Total distance (round trip):',
    locationsSelected: 'Selected locations:',
    calculateRoute: 'Calculate route now',
    resetForm: 'Clear form',
    generateQuotation: 'Generate Quotation',
    calculating: 'Calculating...',
    loadStatusHelp: 'Select if the vehicle is loaded or empty for this segment. Empty vehicles consume less fuel.',
    defaultValue: 'Default value: 1.5 USD',
    advancedMode: 'Advanced Mode',
    advancedModeDescription: 'Shows additional configuration options like cargo type and cost parameters',
    enableAdditionalDestinations: 'Enable Additional Destinations',
    additionalDestinationsDescription: 'Allows adding up to 5 intermediate destinations for complex routes',
    route: {
      oneWay: 'one way',
      roundTrip: 'round trip'
    },
    
    // Tooltips for form sections
    tooltips: {
      vehicleConfig: "Select the vehicle and trailer type according to your cargo needs. This will affect transportation costs, fuel consumption and cargo capacities.",
      costParams: "Configure cost parameters to customize your quotation. Includes fuel price, profit margin and tax adjustments.",
      cargoType: "The cargo type influences the risk factor and security recommendations for transport. Dangerous or valuable cargo has a higher risk factor.",
      fuelPrice: "Current fuel price per liter or gallon. This value directly affects the transportation cost calculation.",
      fuelUnit: "Select whether the fuel price is in liters or gallons. Calculations are performed internally in liters with automatic conversion (1 gallon = 3.78541 liters).",
      profitMargin: "Percentage of profit applied over base cost. Determines operation profitability.",
      taxVat: "VAT percentage applied to toll costs. Discounted to obtain value without tax.",
      currency: "Select the currency in which you want to view results. All costs will be automatically converted to the selected currency.",
      route: "Configure the transport route including origin, destination and any intermediate stops. Location accuracy affects calculation precision.",
      tollDetails: "Shows detailed information about tolls on the selected route, including costs and available payment methods."
    },
    
    // Waypoint translations
    waypoints: {
      stops: 'Intermediate Stops',
      addStops: 'Add intermediate stops',
      noStops: 'No intermediate stops. Add up to 5 stops.',
      stop: 'Stop',
      intermediateStop: 'Intermediate stop',
      addStop: 'Add stop',
      removeStop: 'Remove stop',
      loaded: 'Loaded',
      empty: 'Empty',
      // New translations for waypoints as next destinations
      nextDestinations: 'Additional Destinations',
      nextDestination: 'Destination',
      addDestination: 'Add destination',
      maxReached: 'Maximum of {max} additional destinations reached.',
      noDestinations: 'No additional destinations. You can add up to 5 destinations in sequence.',
      routeDescription: 'The route will be calculated in this exact order: Origin → Main Destination → Additional Destinations.',
      firstSegmentLoad: 'Load Status for First Segment',
      loadStatusHelp: 'Select if the vehicle is loaded or empty for this segment'
    },
    
    // Segment information
    segments: {
      title: 'Segment Information',
      segment: 'Segment',
      totalDistance: 'Total distance:',
      estimatedTime: 'Estimated time:',
      multiSegmentRoute: 'Multi-Segment Route Information'
    },
    
    // Results section
    result: {
      title: 'Quotation Result',
      calculated: 'Calculated',
      tripDetails: 'Trip Details',
      configuration: 'Selected Configuration',
      origin: 'Origin:',
      destination: 'Destination:',
      oneWayDistance: 'Distance (one way):',
      roundtripDistance: 'Total distance (round trip):',
      vehicle: 'Vehicle:',
      merchandise: 'Cargo:',
      fuel: 'Fuel:',
      profit: 'Profit margin:',
      riskFactor: 'Risk factor:',
      taxDiscount: 'Tax discount:',
      currency: 'Currency:',
      totalCost: 'Total Cost',
      baseCost: 'Base Cost:',
      plusProfit: '+ Profit',
      plusRisk: '+ Risk Factor:',
      costBreakdown: 'Cost Breakdown',
      saveQuotation: 'Save Quotation',
      downloadPDF: 'Download PDF',
      downloadMapImage: 'Download Map Image',
      with: 'with'
    },
    
    // Cost breakdown items
    costItems: {
      depreciation: 'Depreciation',
      insurance: 'Insurance',
      gps: 'GPS',
      registration: 'Registration',
      mechanicalVerification: 'Mechanical Verification',
      emissionVerification: 'Emission Verification',
      driverSalary: 'Driver Salary',
      driverBenefits: 'Driver Benefits',
      maintenance: 'Maintenance',
      tireCost: 'Tires',
      fuelCost: 'Fuel',
      tollCost: 'Tolls',
      profit: 'Profit',
      riskFactor: 'Risk Factor (Cargo)',
      total: 'Total',
      tollDetailsSectionTitle: 'Toll Details',
      noVat: 'No VAT',
      reducedRate: 'Reduced rate',
      standardVat: 'Standard VAT',
      specialRate: 'Special rate',
      highRate: 'High rate',
      veryHighRate: 'Very high rate',
      extremeRate: 'Extreme rate',
      maximumRate: 'Maximum rate',
      exceptionalRate: 'Exceptional rate',
      limitRate: 'Limit rate'
    },
    
    // Errors and warnings
    errors: {
      missingInfo: 'Missing required information',
      calculationFailed: 'Error calculating quotation',
      saveFailed: 'Error saving quotation',
      routeNotFound: 'No route found between these points',
      routeCalculationFailed: 'Error calculating route',
      tollCalculationFailed: 'Error calculating toll costs',
      unknownError: 'Unknown error',
      tollApiError: 'Could not obtain toll data',
      generateToSee: 'Generate quotation to see toll details',
      costsMayNotIncludeTolls: 'Total cost may not include toll charges',
      emailRequired: 'Email is required',
      emailNotFound: 'No account exists with this email',
      resetPasswordFailed: 'An error occurred while sending the password reset email',
      passwordRequirements: 'Password must have at least 8 characters, one uppercase letter and one number',
      passwordsMismatch: 'Passwords do not match',
      nameRequired: 'Name is required',
      cityRequired: 'City is required',
      postalCodeRequired: 'Postal code is required',
      phoneRequired: 'Phone number is required',
      authError: 'An error occurred during authentication',
      mapImageMissing: 'No map image available for download',
      downloadFailed: 'Error downloading image'
    },
    helpers: {
      missingVehicleType: 'Vehicle type',
      missingOrigin: 'Origin location',
      missingDestination: 'Destination location',
      routeNotCalculated: 'Route calculation',
      missingAdditionalDestinationLocation: 'Additional destination locations',
      missingInfoDetails: 'Missing: {{details}}',
      clickToSeeRequirements: 'Hover to see missing requirements'
    }
  },
  
  // Toll Details
  tollDetails: {
    title: 'Tolls',
    updated: 'Updated:',
    totalTollCost: 'Total Toll Cost',
    lastUpdated: 'Last updated',
    showTolls: 'Show tolls',
    totalTollbooths: 'Total Tollbooths',
    totalDistance: 'Total Distance',
    totalCost: 'Total Cost',
    vehicleInfo: 'Toll costs are calculated according to vehicle type, number of axles and dimensions.',
    tollTable: {
      tollbooth: 'Tollbooth',
      operator: 'Operator',
      distance: 'Distance',
      cost: 'Cost',
      paymentMethods: 'Payment Methods'
    },
    vatTitle: 'VAT/Tax',
    originalCost: 'Original Cost:',
    vatDiscount: 'VAT/Tax',
    finalCost: 'Final Cost:',
    tollNote: 'Toll costs are based on real information and may vary by season.',
    onewayNote: 'Note: Costs shown include one way only.'
  },
  
  // Routes display
  alternateRoutes: 'Alternative Routes',
  route: 'Route',
  
  // Quotation History
  history: {
    title: 'Quotation History',
    subtitle: 'Your recent quotations',
    noQuotations: 'No quotations',
    noQuotationsMsg: 'You have not made any quotations yet. Create a new one to see it here.',
    confirmDelete: 'Confirm',
    deleteSuccess: 'Quotation deleted successfully.',
    deleteError: 'Error deleting quotation. Please try again.',
    quotationWith: 'with',
    profitMargin: 'With {{margin}}% profit',
    profitMarginZero: 'No profit margin (0%)',
    routeDetails: 'Route Details',
    origin: 'Origin:',
    destination: 'Destination:',
    oneWayDistance: 'Distance (one way):',
    date: 'Date:',
    multiSegmentRoute: 'Multi-segment route:',
    segments: 'segments',
    totalCost: 'Total Cost',
    baseCost: 'Base Cost:',
    profit: 'Profit',
    riskFactor: 'Risk factor',
    total: 'Total:',
    routeMap: 'Route Map',
    download: 'Download',
    noMapImage: 'No map image available',
    configuration: 'Configuration',
    vehicle: 'Vehicle:',
    trailer: 'Trailer:',
    noTrailer: 'No trailer',
    cargo: 'Cargo:',
    risk: 'Risk:',
    downloadMap: 'Download map',
    transactionTypes: {
      used: 'Used',
      purchased: 'Purchased',
      initial: 'Initial',
      added: 'Added'
    }
  },
  
  // Payment methods
  paymentMethods: {
    cash: 'Cash',
    card: 'Card',
    tag: 'TAG',
    iave: 'IAVE'
  },
  
  // Token system
  tokens: {
    available: 'quotation credits available',
    token: 'quotation credit available',
    noTokens: 'You do not have enough credits to make quotations.',
    lowTokens: 'You have few credits left. Consider purchasing more.',
    unlimited: 'Unlimited Credits',
    buy: 'Buy Credits',
    history: 'History',
    adminAccess: 'Administrative Access (Unlimited Credits)',
    loading: 'Loading credits...',
    noAvailable: 'No credits available',
    transaction: {
      quotationGenerated: 'Quotation generated'
    },
    confirmationModal: {
      title: 'Confirm generation',
      insufficientTitle: 'Insufficient credits',
      useToken: 'This action will use 1 quotation credit from your account. You currently have',
      pdfsIncluded: 'After generating the quotation, you can download it as PDF or save it at no additional cost.',
      noTokens: 'You do not have enough credits to generate a new quotation.',
      buyMore: 'Please purchase more credits to continue using the service.',
      confirm: 'Confirm and Generate',
      buy: 'Buy Credits',
      cancel: 'Cancel',
      processing: 'Processing...'
    },
    limitModal: {
      title: 'Credit Limit Reached',
      message: 'You have exhausted your credits to make quotations. To continue using the system, you need to purchase more credits.',
      whatToDo: 'What can you do?',
      buyTokens: 'Purchase one of our credit packages to continue making quotations and accessing all system functionalities.',
      close: 'Close'
    },
    purchase: {
      title: 'Buy Credit Packages',
      subtitle: 'Select the credit package you want to purchase to make more quotations.',
      mostPopular: 'Most popular',
      tokens: 'credits',
      continue: 'Continue to Payment',
      preparingPayment: 'Preparing payment...',
      errorPackageNotFound: 'Credit package not found',
      errorPaymentIntent: 'Client secret not received from server',
      successTitle: 'Purchase Successful!',
      successMessage: 'Credits have been added to your account correctly.'
    },
    checkout: {
      summary: 'Purchase summary',
      package: 'Package:',
      tokens: 'Credits:',
      price: 'Price:',
      paymentInfo: 'Payment information',
      billingAddress: 'Billing address',
      payNow: 'Pay Now',
      processing: 'Processing...',
      paymentSucceeded: 'Payment completed successfully!',
      paymentProcessing: 'Your payment is being processed.',
      requiresPaymentMethod: 'Please provide a payment method.',
      paymentError: 'Something went wrong.',
      processingError: 'Error processing payment. Please try again.',
      genericError: 'An error occurred with your payment',
      unexpectedError: 'An unexpected error occurred'
    },
    transactionHistory: {
      title: 'Transaction History',
      noTransactions: 'No credit transactions recorded',
      loading: 'Loading history...',
      usedQuotationsSectionTitle: 'Used Quotations',
      purchasedCreditsSectionTitle: 'Purchased/Acquired Credits',
      tokensAmount: 'Credits',
      description: 'Description',
      date: 'Date',
      type: 'Type',
      filterAll: 'All Transactions',
      filterUsed: 'Used Quotations',
      filterAcquired: 'Purchased/Acquired'
    },
    packages: {
      test_1: {
        name: 'Test Plan',
        description: 'Test Plan with 1 quotation credit'
      },
      basic_10: {
        name: 'Basic Plan',
        description: 'Basic Plan with 10 quotation credits'
      },
      pro_20: {
        name: 'Pro Plan',
        description: 'Pro Plan with 20 quotation credits'
      },
      premium_50: {
        name: 'Premium Plan',
        description: 'Premium Plan with 50 quotation credits'
      }
    }
  },
  
  // Vehicle types - Using normalized keys for consistent lookup
  vehicles: {
    camionetadecargasencilla: "Light Cargo Pickup",
    camionetadecargacondoblerodado: "Dual-Wheel Cargo Pickup",
    rabon: "Rabon",
    torton: "Torton",
    unidadensencilloconunremolquede2ejes: "Tractor with 2-Axle Trailer",
    unidadensencilloconunremolquede3ejes: "Tractor with 3-Axle Trailer",
    unidadenfullcon6ejesentotal: "Full Unit with 6 Axles",
    unidadenfullcon7ejesentotal: "Full Unit with 7 Axles",
    unidadenfullcon8ejesentotal: "Full Unit with 8 Axles",
    unidadenfullcon9ejesentotal: "Full Unit with 9 Axles"
  },
  
  // Trailer types - Using normalized keys for consistent lookup
  trailers: {
    cajaseca: "Dry Box",
    cajarefrigerada: "Refrigerated Box",
    plataforma: "Platform",
    portacontenedor: "Container Carrier",
    jaulagranelera: "Grain Cage",
    tolvagranelera: "Grain Hopper",
    tolvapresurizada: "Pressurized Hopper",
    tanquedeliquidos: "Liquid Tank",
    lowboy: "Lowboy"
  },
  
  // Cargo types
  cargo: {
    generalmerchandise: "General Merchandise",
    perishablefood: "Perishable Food",
    nonperishablefood: "Non-Perishable Food",
    constructionmaterials: "Construction Materials",
    agriculturalproducts: "Agricultural Products",
    furniture: "Furniture",
    clothingtextiles: "Clothing and Textiles",
    electronics: "Electronics",
    automotiveparts: "Automotive Parts",
    householdappliances: "Household Appliances",
    steelmetals: "Steel and Metals",
    chemicals: "Chemicals",
    hazardousmaterials: "Hazardous Materials",
    fragileitems: "Fragile Items",
    highvaluegoods: "High-Value Goods",
    machinery: "Machinery",
    livestock: "Livestock",
    pharmaceuticals: "Pharmaceuticals",
    woodproducts: "Wood Products",
    other: "Other"
  },
  
  // Admin panel
  admin: {
    title: 'Admin Panel',
    usersManagement: 'User Management',
    total: 'Total:',
    users: 'users',
    search: 'Search users...',
    refresh: 'Refresh',
    usersTab: 'Users',
    reportsTab: 'Global Reports',
    table: {
      name: 'Name',
      email: 'Email',
      tokens: 'Credits',
      status: 'Status',
      actions: 'Actions'
    },
    status: {
      admin: 'Admin',
      noTokens: 'No tokens',
      lowTokens: 'Low tokens',
      active: 'Active',
      administrator: 'Administrator',
      user: 'User',
      unlimited: 'Unlimited'
    },
    addTokens: 'Add tokens',
    addTokensForm: {
      title: 'Add Tokens',
      amount: 'Number of Credits',
      description: 'Description',
      addTokens: 'Add Credits',
      addCredits: 'Add Credits',
      processing: 'Processing...',
      cancel: 'Cancel',
      success: '{{count}} tokens added successfully',
      error: 'Could not add tokens. Please try again.',
      defaultDescription: 'Tokens assigned by administrator'
    },
    userDetail: 'User Detail',
    transactionHistory: 'Transaction History',
    noTransactions: 'No transactions recorded for this user',
    loadingTransactions: 'Loading transactions...',
    noUsersFound: 'No users found',
    loadingUsers: 'Loading users...',
    errorLoading: 'Error loading user information',
    errorUpdating: 'Error updating users',
    accessDenied: {
      title: 'Access Denied',
      message: 'You do not have permissions to access the admin panel.'
    },
    transactionTable: {
      date: 'Date',
      type: 'Type',
      amount: 'Amount',
      description: 'Description'
    },
    transactionTypes: {
      used: 'Used',
      purchased: 'Purchased',
      initial: 'Initial',
      added: 'Added'
    },
    reports: {
      title: 'Global Reports',
      errorLoading: 'Error loading report. Please try again.',
      dateRanges: {
        last7Days: 'Last 7 Days',
        last30Days: 'Last 30 Days',
        last90Days: 'Last 90 Days',
        allTime: 'All Time'
      },
      summary: {
        totalQuotations: 'Total Quotations',
        uniqueUsers: 'Unique Users',
        totalDistance: 'Total Distance',
        averageCost: 'Average Cost'
      },
      countryDestinations: {
        title: 'Quotations by Destination Country',
        noData: 'No destination data for the selected period',
        tableHeaders: {
          country: 'Country',
          quotations: 'Quotations',
          percentage: 'Percentage',
          cities: 'Cities'
        },
        showCities: 'Show {{count}} cities',
        hideCities: 'Hide'
      },
      topRoutes: {
        title: 'Most Popular Routes',
        noData: 'No route data for the selected period',
        tableHeaders: {
          origin: 'Origin',
          destination: 'Destination',
          quotations: 'Quotations',
          avgDistance: 'Avg. Distance',
          avgCost: 'Avg. Cost'
        }
      },
      vehicleTypes: {
        title: 'Vehicle Types',
        noData: 'No vehicle data'
      },
      cargoTypes: {
        title: 'Cargo Types',
        noData: 'No cargo type data'
      },
      export: {
        button: 'Export CSV',
        filename: 'global-report'
      },
      csv: {
        title: 'Global Quotations Report',
        summary: 'SUMMARY',
        totalQuotations: 'Total Quotations',
        uniqueUsers: 'Unique Users',
        totalDistance: 'Total Distance (km)',
        averageCost: 'Average Cost',
        startDate: 'Start Date',
        endDate: 'End Date',
        countryDestinations: 'DESTINATIONS BY COUNTRY',
        countryHeaders: 'Country,Code,Quotations,Percentage',
        topRoutes: 'MOST POPULAR ROUTES',
        routeHeaders: 'Origin,Destination,Quotations,Average Distance (km),Average Cost',
        vehicleTypes: 'VEHICLE TYPES',
        vehicleHeaders: 'Vehicle Type,Quotations,Percentage'
      }
    }
  },
  
  // Session timeout
  sessionTimeout: {
    warningMessage: "Your session will be automatically closed in 3 minutes due to inactivity.",
    closedMessage: "Your session has been closed due to inactivity."
  },
  
  // PDF generation
  pdf: {
    title: 'Heavy Cargo Transportation Quotation System',
    routeInfo: 'Route Information',
    origin: 'Origin',
    destination: 'Destination',
    additionalDestination: 'Additional Destination',
    additionalDestinations: 'Additional Destinations',
    distance: 'Distance (one way)',
    totalDistance: 'Total distance (round trip)',
    equipmentConfig: 'Equipment Configuration',
    unitType: 'Unit Type',
    trailerType: 'Trailer Type',
    cargoType: 'Cargo Type',
    riskFactor: 'Risk Factor',
    costInfo: 'Cost Information',
    disclaimer: 'Note: Fuel and tire wear costs are calculated considering round trip distance.',
    driverSalaryNote: 'Driver salary is calculated based on one-way distance.',
    tollNote: 'Toll costs only include one-way trip.',
    currencyNote: 'All amounts are expressed in',
    validityNote: 'This quotation is valid for 15 days from the date of issue.',
    page: 'Page',
    of: 'of',
    detailedCostBreakdown: 'Detailed Cost Breakdown',
    route: 'Route:',
    equipment: 'Equipment:',
    concept: 'Concept',
    amount: 'Amount',
    tollDetails: 'Toll Details',
    lastUpdated: 'Last updated:',
    tollTable: {
      tollbooth: 'Tollbooth',
      operator: 'Operator',
      distance: 'Distance',
      cost: 'Cost',
      paymentMethods: 'Payment Methods'
    },
    tollTotal: 'Total Toll Costs:',
    tollOneWayNote: 'Costs shown include one way only.',
    securityRecommendations: 'Security Recommendations:',
    responsibilityNote: 'Note: The security recommendations provided are for guidance and are not exhaustive.',
    regulationsNote: 'It is recommended to comply with all applicable regulations for transporting this type of cargo.',
    mapRoute: 'Route:',
    mapCantLoad: 'Error loading route map',
    mapCantLoadDesc: 'Could not process map image for this quotation.',
    date: 'Date',
    company: {
      name: 'Cotizatrin',
      address: 'Tallinn, Estonia',
      phone: '',
      email: 'info_cotizatrin@autotrin.com',
      website: 'www.cotizatrin.com'
    },
    securityInfo: {
      title: 'Cargo and Security Information',
      description: 'Risk Description:',
      recommendationsTitle: 'Security Recommendations:',
      responsibilityNote: 'Note: The security recommendations provided are for guidance and are not exhaustive.',
      regulationsNote: 'It is recommended to comply with all applicable regulations for transporting this type of cargo.'
    },
    notes: {
      title: 'Important Notes',
      validity: 'This quotation is valid for 15 days from the date of issue.',
      termsReference: 'For complete terms and conditions, visit www.cotizatrin.com/terms',
      disclaimer: 'Prices are subject to change without notice according to market conditions.'
    },
    segments: {
      info: 'Segment Information',
      multiSegmentRoute: 'Multi-Segment Route Information',
      description: 'This quotation includes {count} route segments with different load statuses.',
      segment: 'Segment',
      loaded: 'Loaded',
      empty: 'Empty'
    }
  },
  
  // Loading Overlay
  loadingOverlay: {
    message: 'Please wait a few moments while we calculate all costs, including tolls and taxes.'
  },
  
  // Terms, policies, etc.
  legal: {
    termsConditions: 'Terms and Conditions',
    privacyPolicy: 'Privacy Policy'
  },
  
  // Language switcher
  language: {
    switch: 'Switch language',
    es: 'Español',
    en: 'English',
    spanish: 'Spanish',
    english: 'English',
    selectAppLanguage: 'Choose the language you prefer to use the application',
    label: 'Language'
  },
  
  // Errors
  errors: {
    missingInfo: 'Missing required information',
    calculationFailed: 'Error calculating quotation',
    saveFailed: 'Error saving quotation',
    routeNotFound: 'No route found between these points',
    routeCalculationFailed: 'Error calculating route',
    tollCalculationFailed: 'Error calculating toll costs',
    unknownError: 'Unknown error',
    emailRequired: 'Email is required',
    emailNotFound: 'No account exists with this email',
    resetPasswordFailed: 'An error occurred while sending the password reset email',
    passwordRequirements: 'Password must have at least 8 characters, one uppercase letter and one number',
    passwordsMismatch: 'Passwords do not match',
    nameRequired: 'Name is required',
    cityRequired: 'City is required',
    postalCodeRequired: 'Postal code is required',
    phoneRequired: 'Phone number is required',
    authError: 'An error occurred during authentication',
    mapImageMissing: 'No map image available for download',
    downloadFailed: 'Error downloading image'
  },
  
  // Terms and Conditions translations
  terms: {
    title: 'Terms and Conditions',
    introduction: {
      title: '1. Introduction',
      content: 'Welcome to Cotizatrin, a heavy cargo transportation quotation platform. By accessing and using our service, you agree to be bound by the following terms and conditions. Please read these terms carefully before using our platform.'
    },
    definitions: {
      title: '2. Definitions',
      intro: 'In these Terms and Conditions',
      cotizatrin: '"Cotizatrin", "we", "us" or "our" refers to the Cotizatrin platform.',
      user: '"User", "you" or "your" refers to any person who accesses or uses the Cotizatrin platform.',
      service: '"Service" refers to the heavy cargo transportation quotation platform provided by Cotizatrin.',
      quotation: '"Quotation" refers to the cost estimate generated by our platform.'
    },
    serviceUse: {
      title: '3. Use of Service',
      intro: 'By using our service, you agree to',
      item1: 'Provide accurate and complete information when registering and using the platform.',
      item2: 'Maintain the confidentiality of your password and account.',
      item3: 'Be responsible for all activities that occur under your account.',
      item4: 'Not use the service for illegal or unauthorized purposes.',
      item5: 'Not attempt to damage, overload or harm in any way the platform operation.'
    },
    quotations: {
      title: '4. Quotations',
      content: 'Quotations generated by our platform are estimates based on the information provided and our calculation algorithms. These quotations:',
      item1: 'Are for informational purposes only and do not constitute a binding offer.',
      item2: 'May vary depending on external factors such as weather conditions, fuel price, etc.',
      item3: 'Have a validity of 15 days from the date of issue, unless otherwise indicated.',
      item4: 'Do not include additional taxes, toll fees, or special charges that may apply.'
    },
    userAccounts: {
      title: '5. User Accounts',
      content: 'To use certain features of our platform, it is necessary to create a user account. By creating an account, you agree to:',
      item1: 'Provide accurate, current and complete information.',
      item2: 'Update your information when necessary to keep it accurate and complete.',
      item3: 'Be solely responsible for protecting the confidentiality of your password.',
      item4: 'Notify us immediately of any unauthorized use of your account.'
    },
    privacy: {
      title: '6. Privacy',
      content: 'We respect your privacy and are committed to protecting your personal data. Our Privacy Policy explains how we collect, use and protect the information you provide. By using our service, you accept our privacy practices.'
    },
    intellectualProperty: {
      title: '7. Intellectual Property',
      content: 'All intellectual property rights related to the Cotizatrin platform, including but not limited to software, designs, logos, texts, graphics and content, are property of Cotizatrin or its licensors. Reproduction, distribution, modification or any other unauthorized use of these materials is prohibited.'
    },
    liability: {
      title: '8. Limitation of Liability',
      content: 'Cotizatrin provides the platform "as is" and "as available," without warranties of any kind. We do not guarantee that the service will be uninterrupted, secure or error-free. In no event shall Cotizatrin be liable for indirect, incidental, special, consequential or punitive damages, including loss of profits, data or use.'
    },
    modifications: {
      title: '9. Modifications',
      content: 'We reserve the right to modify these terms and conditions at any time. Modifications will take effect immediately after publication on the platform. It is your responsibility to periodically review these terms to stay informed of updates.'
    },
    applicableLaw: {
      title: '10. Applicable Law',
      content: 'These terms and conditions shall be governed and interpreted in accordance with the laws of Mexico, without regard to its conflict of laws provisions. Any dispute arising in connection with these terms shall be subject to the exclusive jurisdiction of the competent courts of Mexico City.'
    },
    contact: {
      title: '11. Contact',
      content: 'If you have questions or concerns about these terms and conditions, please contact us at'
    },
    lastUpdate: 'Last update: May 15, 2025'
  },
  
  // Business and Local SEO Information
  business: {
    name: 'Cotizatrin',
    description: 'Specialized platform for heavy cargo transportation quotations with updated toll and route data',
    address: 'Tallinn, Estonia',
    phone: '',
    email: 'info_cotizatrin@autotrin.com',
    hours: {
      title: 'Business Hours',
      weekdays: 'Mon - Fri: 8:00 AM - 6:00 PM',
      saturday: 'Saturday: 9:00 AM - 2:00 PM',
      sunday: 'Sunday: Closed'
    },
    services: {
      title: 'Our Services',
      quotation: 'Heavy Cargo Transportation Quotation',
      tolls: 'Real-Time Toll Calculation',
      routes: 'Optimized Route Analysis',
      security: 'Security Recommendations',
      reports: 'Professional PDF Reports'
    },
    contact: {
      title: 'Contact Information',
      address: 'Address',
      phone: 'Phone',
      email: 'Email',
      viewOnMaps: 'View on Google Maps',
      ourLocation: 'Our Location',
      mapTitle: 'Cotizatrin Location'
    },
    googleBusiness: {
      title: 'Find us on',
      viewProfile: 'View full profile'
    },
    quotationsGenerated: 'Quotations generated'
  },
  
  // Privacy Policy translations
  privacy: {
    title: 'Privacy Policy',
    introduction: {
      title: '1. Introduction',
      content: 'This Privacy Notice describes how Cotizatrin collects, uses, stores and protects the personal information you provide to us through our heavy cargo transportation quotation platform. We are committed to protecting your privacy and complying with all applicable laws and regulations regarding personal data protection.'
    },
    collectedInfo: {
      title: '2. Information We Collect',
      intro: 'We may collect the following types of personal information',
      item1: 'Full name',
      item2: 'Email address',
      item3: 'Phone number',
      item4: 'City and postal code',
      item5: 'Company name (optional)',
      item6: 'Location and route information (origin and destination of quotations)',
      item7: 'Vehicle and cargo information',
      item8: 'Quotation history'
    },
    infoUse: {
      title: '3. Use of Your Information',
      intro: 'We use the collected information to',
      item1: 'Create and manage your account on our platform',
      item2: 'Process and store your transportation quotations',
      item3: 'Calculate accurate transportation costs based on your specifications',
      item4: 'Communicate with you about your account and quotations',
      item5: 'Improve our services and develop new functionalities',
      item6: 'Provide customer service and technical support',
      item7: 'Send relevant information about our services (with your consent)',
      item8: 'Comply with our legal obligations'
    },
    storageSecurity: {
      title: '4. Storage and Security',
      content1: 'Your personal information is stored on secure servers and we use appropriate technical, administrative and physical security measures to protect your data against unauthorized access, use or disclosure. Our systems are designed to maintain the integrity and confidentiality of your information.',
      content2: 'We retain your personal information only for as long as necessary for the purposes described in this privacy notice or as required by law.'
    },
    infoSharing: {
      title: '5. Information Sharing',
      content: 'We do not sell or rent your personal information to third parties. We may share your information in the following circumstances:',
      item1: 'With service providers who help us operate our platform',
      item2: 'When required by law or competent authorities',
      item3: 'To protect our rights, privacy, security or property',
      item4: 'In case of merger, acquisition or asset sale (with appropriate safeguards)'
    },
    cookies: {
      title: '6. Use of Cookies and Similar Technologies',
      content: 'We use cookies and similar technologies to improve your experience on our platform, understand how you use it and personalize our services. You can manage your cookie preferences through your browser settings.'
    },
    userRights: {
      title: '7. Your Rights',
      intro: 'You have the right to',
      item1: 'Access the personal information we hold about you',
      item2: 'Correct inaccurate or incomplete data',
      item3: 'Request deletion of your personal data',
      item4: 'Object to or limit the processing of your data',
      item5: 'Withdraw your consent at any time',
      item6: 'Request portability of your data',
      item7: 'File a complaint with the data protection authority',
      contact: 'To exercise any of these rights, please contact us at'
    },
    policyChanges: {
      title: '8. Changes to this Notice',
      content: 'We may update this Privacy Notice periodically to reflect changes in our information practices or legal requirements. We will post the updated version on our platform with the last update date. We recommend that you review this notice regularly.'
    },
    minors: {
      title: '9. Minors',
      content: 'Our services are not directed to minors under 18 years of age and we do not knowingly collect personal information from minors. If we discover that we have collected personal information from a minor, we will take steps to delete such information as soon as possible.'
    },
    contact: {
      title: '10. Contact',
      content: 'If you have questions or concerns about this Privacy Notice or about the handling of your personal data, contact us at'
    },
    lastUpdate: 'Last update: May 15, 2025'
  },

  // Form Guide translations
  formGuide: {
    title: 'Form Completion Guide for Quotation',
    returnToForm: 'Return to Form',
    introduction: {
      title: 'Introduction',
      content: 'This guide will help you complete the quotation form correctly to get the most accurate cost for your freight transportation. Follow the steps below for a smooth experience.'
    },
    basicMode: {
      title: 'Basic Mode vs. Advanced Mode',
      content: 'The form has two operation modes:',
      basic: 'Basic Mode: Includes vehicle configuration, fuel price, and locations. Ideal for quick quotations.',
      advanced: 'Advanced Mode: Adds cargo type, custom cost parameters, and currency selection. Recommended for more precise and professional quotations.',
      howToEnable: 'To activate Advanced Mode, click the "Advanced" button in the top navigation bar.'
    },
    vehicleSelection: {
      title: 'Vehicle Selection',
      description: 'Vehicle configuration is fundamental for obtaining an accurate quotation:',
      vehicleTypes: 'Available Vehicle Types:',
      pickupTruck: 'Pickup Trucks: For light loads (1.5-3.5 tons)',
      mediumTrucks: 'Rabon and Torton: For medium loads (10-15 tons)',
      tractorTrailers: 'Tractor-Trailers: For heavy loads (25-35 tons)',
      fullUnits: 'Full Units: For very heavy and high-volume loads (40+ tons)',
      trailerSelection: 'Trailer Selection:',
      trailerNote: 'Only appears for vehicles that require a trailer (tractor-trailers and full units)',
      visualSelection: 'Use the visual icons to easily identify the type of vehicle and trailer you need.'
    },
    fuelPrice: {
      title: 'Fuel Price',
      description: 'This section is always visible and fundamental for calculation:',
      currentPrice: 'The system shows an updated default price',
      customPrice: 'You can adjust the price if you have more precise information from your supplier',
      impactNote: 'Fuel price directly affects the total transportation cost'
    },
    locationSelection: {
      title: 'Location Selection',
      originDestination: 'Origin and Destination',
      enterLocations: 'Enter the exact locations for the origin and destination of your freight:',
      option1: 'Type the complete address',
      option2: 'Select from autocomplete suggestions',
      option3: 'Locate the point on the interactive map',
      addressHelper: 'IMPORTANT: Include the most complete address possible (street and number, neighborhood, city, state, postal code) to avoid incorrect locations',
      mapInteraction: 'Map Interaction:',
      dragMarkers: 'You can drag the markers to adjust the exact position',
      mapCalculation: 'The map will automatically calculate the route between selected points',
      clearMap: 'Use the "Clear Map" button to start over',
      routeValidation: 'Verify that the route shown on the map is correct before generating the quotation'
    },
    intermediateStops: {
      title: 'Additional Destinations (Optional)',
      howToEnable: 'How to Enable:',
      enableStep: 'Check the "Enable Additional Destinations" checkbox to activate this functionality',
      description: 'Once enabled, you can add up to 5 additional destinations for complex routes:',
      addingDestinations: 'Adding Destinations:',
      step1: 'Click "Add destination" to add a new location',
      step2: 'Enter the complete address of the destination',
      step3: 'Configure the load status for each segment (loaded/empty)',
      loadStatus: 'Load Status:',
      loadedDesc: 'Loaded: The vehicle transports cargo in that segment',
      emptyDesc: 'Empty: The vehicle travels without cargo (lower fuel consumption)',
      routeSequence: 'Route Sequence:',
      routeOrder: 'The route is calculated in order: Origin → Main Destination → Additional Destination 1 → Additional Destination 2, etc.',
      optimization: 'The system does NOT automatically reorder to optimize the route',
      costCalculation: 'Cost Calculation:',
      segmentCosts: 'Each segment is calculated individually according to its load status',
      limitations: 'Important Considerations:',
      tollAccuracy: 'Many destinations may affect the accuracy of toll calculations',
      routeComplexity: 'Very complex routes may take longer to process'
    },
    advancedMode: {
      title: 'Advanced Mode Features',
      description: 'Advanced Mode adds professional options for more precise quotations:',
      howToEnable: 'How to Activate:',
      enableButton: 'Click the "Advanced" button in the top navigation bar',
      sections: 'Additional Sections:',
      cargoType: 'Cargo Type:',
      cargoTypeDesc: 'Select the specific type of cargo you will transport. This affects the risk factor and security recommendations.',
      riskFactors: 'Risk Factors:',
      riskGeneral: 'General Merchandise: Standard factor (1.0x)',
      riskPerishable: 'Perishable Food: High factor (1.3x)',
      riskElectronics: 'Electronics: Very high factor (1.4x)',
      riskHazardous: 'Hazardous Materials: Extreme factor (1.8x)',
      costParameters: 'Cost Parameters:',
      profitMargin: 'Profit Margin: Define the percentage of profit over the base cost',
      vatTax: 'VAT/Tax: Tax percentage applied to toll costs',
      currencySelection: 'Currency Selection:',
      currencyDesc: 'Choose the currency in which you want to see all results (MXN, USD, EUR, etc.)',
      conversionNote: 'All costs will be automatically converted to the selected currency'
    },
    generatingQuotation: {
      title: 'Generating Quotation',
      requirements: 'Requirements to Generate:',
      reqVehicle: 'Select vehicle type (and trailer if applicable)',
      reqLocations: 'Enter valid origin and destination',
      reqRoute: 'Calculate the route on the map',
      reqTokens: 'Have at least 1 quotation credit available',
      reviewGenerate: 'Generation Process:',
      step1: 'Review that the information is correct',
      step2: 'Click the green "Generate Quotation" button',
      step3: 'Confirm that you want to use 1 credit for this calculation',
      step4: 'Wait while the information is processed and tolls are calculated',
      automaticSave: 'Automatic Save:',
      autoSaveDesc: 'The quotation is automatically saved to your history after generation',
      resultIncludes: 'The generated quotation will include:',
      detailedBreakdown: 'Detailed cost breakdown in the selected currency',
      tollInfo: 'Toll booth information with converted costs',
      securityRecommendations: 'Security recommendations based on cargo type (advanced mode)',
      routeMap: 'Route map',
      afterGenerate: 'After Generating',
      afterGenerateDesc: 'Once the quotation is generated, you can:',
      newQuotation: 'Create a "New Quotation" with the blue button',
      changeCurrency: 'Change the currency to view costs in different denominations',
      downloadPDF: 'Download the quotation in PDF format (it will be generated in the selected currency)',
      downloadMap: 'Download only the route map image',
      viewHistory: 'View quotation history in the corresponding tab',
      tokenNote: 'Each generated quotation consumes one token. If you need to create multiple variants, consider acquiring an additional token package.'
    },
    tips: {
      title: 'Tips for Better Results',
      tip1: 'Use complete addresses with postal code for greater accuracy',
      tip2: 'Verify that the route on the map is correct before generating',
      tip3: 'Advanced mode provides more professional and detailed quotations',
      tip4: 'Load statuses (loaded/empty) significantly affect fuel costs',
      tip5: 'Save important quotations by downloading the PDF'
    },
    additionalHelp: {
      title: 'Need Additional Help?',
      content: 'If you have specific questions about how to complete any part of the form or need personalized assistance, contact our support team:'
    }
  },
  
  // Map component translations
  mapComponent: {
    loading: 'Loading Map...',
    errorLoading: 'Error loading Google Maps',
    calculateRoute: 'Calculate Route',
    calculating: 'Calculating...',
    routeNotFound: 'No route found between these points',
    placesLoading: 'Loading Google Maps services...',
    locationSelected: 'Location selected successfully',
    instructions: 'Map Instructions',
    instructionsMap: 'Select origin and destination, then click "Calculate Route"',
    instructionsDragMarkers: 'Or click on the map to place markers and drag them to adjust position',
    clearMap: 'Clear Map',
    calculateRouteNow: 'Calculate Route Now',
    locationConfirmed: '✓ Location established',
    routeSequence: 'Route sequence: Origin → Main Destination → Additional Destinations',
    destinationMarker: 'Main destination (B)',
    additionalMarker: 'Additional destination',
    waypointMarker: 'Waypoint',
    originMarker: 'Origin (A)'
  },
  
  // Location selection section
  locationSelection: {
    title: 'Location Selection',
    originCountryLabel: 'Origin Country/Region',
    destinationCountryLabel: 'Destination Country/Region',
    originCountryHelper: 'Country where the origin location is located',
    destinationCountryHelper: 'Country where the destination location is located',
    instructions: 'Enter exact locations for origin and destination',
    option1: 'Enter the complete address in the field',
    option2: 'Select from autocomplete suggestions',
    option3: 'Click directly on the map to place markers',
    tip: 'Accurate locations result in more precise quotations',
    checkMap: 'Verify that both markers appear correctly on the map',
    noRoute: 'If necessary, adjust marker positions by dragging them',
    clearMap: 'Use "Clear Map" to start over',
    routeOrder: 'The route will be calculated in this order:',
    routeSequence: '1. Origin → 2. Main Destination → 3. Additional Destinations',
    locationInputHelper: 'For greater accuracy, include: street and number, neighborhood/district, city, state and postal code.',
    countrySelection: 'Country Selection',
    countrySelectionHelper: 'Select the country where the addresses are located to improve accuracy',
    countrySelectionTip: 'Selecting the correct country prevents location errors and improves address accuracy',
    originCountry: 'Origin country',
    destinationCountry: 'Destination country',
    internationalRoute: 'International Route',
    internationalRouteHelper: 'Select different countries for origin and destination if this is an international route',
    additionalDestinationsCountry: 'Additional destinations country',
    additionalDestinationsCountryHelper: 'Country where additional destinations are located to improve search accuracy'
  },
  
  // Quotation section with missing translations
  quotation: {
    additionalDestinationsCountry: 'Additional destinations country',
    additionalDestinationsCountryHelper: 'Country where additional destinations are located to improve search accuracy',
    internationalRoute: 'International Route',
    internationalRouteHelper: 'Select different countries for origin and destination if this is an international route'
  },

  // PWA Installation Prompt
  pwa: {
    install: {
      title: 'Install Cotizatrin',
      description: 'Get faster access and a better experience',
      benefit1: 'Direct access from your home screen',
      benefit3: 'Get instant notifications',
      installButton: 'Install',
      notNow: 'Not now',
      installing: 'Installing...'
    }
  }
}